<template>
    <div class="members__logo">
        <img :src="member.logoUrl" :alt="member.logoTitle"/>
    </div>
</template>
<script>
export default {
    name: 'members-item',
    data: function() {
        return {
        };
    },
    props: {
        member: Object
    },
}
</script>


// WEBPACK FOOTER //
// Item.vue?15ceabb9